// extracted by mini-css-extract-plugin
export default {"container":"md_message_container__h16Gs","quotation_container":"md_message_quotation_container__y1mKG","top_container":"md_message_top_container__TMDmP"};